<template>
  <div class="offer" v-bind:style="{ color: background, background: hex}">
    <div class="offer-tri">
      <!-- <svg version="1.1"
             id="Layer_1"
             xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px"
             y="0px"
             viewBox="0 0 293 94"
             style="enable-background:new 0 0 293 94;"
             xml:space="preserve"
             preserveAspectRatio="none"
             :fill="background">
          <polygon points="0,0 293,0 293,94 " />
        </svg> -->
    </div>
    <div class="content">
      <h3>
        Get the app
      </h3>
      <p>
        Currently building this tool as an app with even more great featrures to live in your taskbar and possibly phone.  Would you like to try it out?
      </p>

      <div id="mc_embed_signup" class="signup-form">
        <form action="https://robsarve.us20.list-manage.com/subscribe/post?u=76ad09e3cf8aed61d5ebd82f1&amp;id=5e55e804e3" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
            <div id="mc_embed_signup_scroll">
        <div class="mc-field-group">
          <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" placeholder="john@doe.com"
            v-bind:style="{
              borderBottomColor: background,
              color: background
              }"
          >

           <input type="submit" value="Learn more" name="subscribe" id="mc-embedded-subscribe" class="button"
                v-bind:style="{
                borderColor: background,
                background: background,
                color: hex
              }"/>
        </div>
          <div id="mce-responses" class="clear">
            <div class="response" id="mce-error-response" style="display:none"></div>
            <div class="response" id="mce-success-response" style="display:none"></div>
          </div>
            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_76ad09e3cf8aed61d5ebd82f1_5e55e804e3" tabindex="-1" value=""></div>
            <div class="clear">
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['hex'],
  mounted() {
  },
  computed: {
    contrast() {
      return Number(this.$store.getters.contrast);
    },
    background() {
      return this.$store.getters.background.color.hex()
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import '../offer';
</style>
